export default [
    {
        path: '/airline',
        props: true,
        component: () => import('@/views/Airline'),
    },
];